<div
  (mouseenter)="onEnter()"
  (mouseleave)="onLeave()"
  class="group flex flex-col gap-8 pt-2 pb-4 px-1 left-0 top-0 bg-white max-w-12 min-w-12 overflow-hidden hover:min-w-56 hover:max-w-56 transition-all ease-in-out h-full"
>
  <div class="relative flex-1 min-h-0">
    <div
      #viewport
      (scroll)="onScroll()"
      class="flex flex-col gap-2 h-full overflow-x-hidden overflow-y-hidden group-hover:overflow-y-auto [scrollbar-width:thin] [scrollbar-color:var(--border-color)_transparent]"
    >
      @for (section of this.menuStructureService.sidebarMenu; track $index) {
        <!-- only display section when it has at least one item displayed -->
        @if (
          this.navItemAccessService.sectionHasAtLeastOneItemAllowedToAccess(
            section.items
          )()
        ) {
          <div class="flex flex-col gap-1">
            <!-- title -->
            <pm-section-title
              [title]="section.title"
              [isHovered]="this.isHovered()"
            />
            <!-- nav items -->
            @for (item of section.items; track $index) {
              @if (this.navItemAccessService.allowedToAccess(item)()) {
                <pm-nav-item [navItem]="item" />
              }
            }
          </div>
        }
      }
    </div>

    @if (this.canScrollUp()) {
      <div
        class="pointer-events-none absolute inset-x-0 top-0 h-6 bg-gradient-to-b from-white to-transparent"
      ></div>
    }
    @if (this.canScrollDown()) {
      <div
        class="pointer-events-none absolute inset-x-0 bottom-0 h-6 bg-gradient-to-t from-white to-transparent"
      ></div>
    }
  </div>

  <div class="shrink-0 flex flex-col gap-1">
    @for (item of this.menuStructureService.sidebarBottomMenu; track $index) {
      @if (this.navItemAccessService.allowedToAccess(item)()) {
        <pm-nav-item [navItem]="item" />
      }
    }
  </div>
</div>
